import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import SHADOWS from "components/atoms/shadows";
import { TextSm } from "components/atoms/text";
import HEADER_HEIGHT from "components/atoms/headerHeight";

interface Props {
  content: string;
  isShow: boolean;
}

const Toast = ({ content, isShow }: Props) => {
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (isShow) {
      setShow(true);

      const timer = setTimeout(() => {
        setShow(false);
      }, 5000);

      return () => clearTimeout(timer);
    } else {
      setShow(false);
    }
  }, [isShow]);

  return (
    <Container show={show}>
      <Wapper>
        <TextSm className="text-white">{content}</TextSm>
      </Wapper>
    </Container>
  );
};

const Container = styled.div<{ show: boolean }>`
  position: fixed;
  left: 50%;
  top: -${HEADER_HEIGHT}px;
  z-index: 20;
  opacity: 0;
  transform: translateX(-50% + 342px);
  display: flex;
  justify-content: center;
  transition: all ease 1s;

  ${({ show }) =>
    show &&
    css`
      opacity: 1;
      top: 100px;
    `}
`;

const Wapper = styled.div`
  display: inline-flex;
  padding: 20px;
  align-items: center;
  border-radius: 8px;
  background: var(--black-blur, rgba(0, 0, 0, 0.7));
  box-shadow: ${SHADOWS.modal};
  user-select: none;
`;

export default Toast;
